module.exports = __webpack_public_path__ + "img/has-file.6972e4b9.svg";